<script setup lang="ts">
import { StoreState } from '@/core/models/store.interface';
import { computed } from 'vue';
import { useStore } from 'vuex';
import ConfirmationModal from '../status-elements/ConfirmationModal.vue';

const { state } = useStore<StoreState>();

const confirmModalData = computed(() => state.modal?.confirmModalData);
const showConfirmModal = computed(() => state.modal?.showConfirmModal);
</script>

<template>
   <Transition name="fade">
      <ConfirmationModal v-if="showConfirmModal" v-bind="confirmModalData" />
   </Transition>
</template>
